<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3592_2494)">
      <path
        d="M0.666626 13.8333V9.83325H4.66663"
        stroke="#4C4C60"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.3334 3.16675V7.16675H11.3334"
        stroke="#4C4C60"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.33996 6.49989C2.67807 5.54441 3.25271 4.69016 4.01027 4.01683C4.76783 3.34351 5.6836 2.87306 6.67215 2.64939C7.6607 2.42572 8.6898 2.45612 9.66342 2.73774C10.637 3.01936 11.5235 3.54303 12.24 4.25989L15.3333 7.16655M0.666626 9.83322L3.75996 12.7399C4.47646 13.4567 5.36287 13.9804 6.3365 14.262C7.31012 14.5437 8.33922 14.5741 9.32777 14.3504C10.3163 14.1267 11.2321 13.6563 11.9896 12.9829C12.7472 12.3096 13.3218 11.4554 13.66 10.4999"
        stroke="#4C4C60"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3592_2494">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
